import { ROOT_URL } from '../actions'

export const trolleyScanApi = {
  UPDATE_TROLLEY_PACKAGES: `${ROOT_URL}/hms/get_temporary_group_details/`
}